import { getImageUrl } from '@helpers/image';
import React from 'react';
import { LinkButton } from '../Buttons/GeneralButton/Button';
import { OfferDetailCardStyles as S } from './OfferDetailCard.styles';
const OfferDetailCard = (props) => {
    return (React.createElement(S.Container, { href: props.buttonLink, "data-visible": props.visible, style: { '--i': props.index } },
        React.createElement(S.ImageContainer, null,
            React.createElement(S.Image, { alt: props.offerImageAltText ?? '', loading: "lazy", role: props.offerImageAltText ? undefined : 'presentation', src: getImageUrl(props.offerImage, { mode: 'crop', width: 600, heightratio: 334 / 380 }), srcSet: [
                    `${getImageUrl(props.offerImage, { mode: 'crop', width: 600, heightratio: 334 / 380 })} 1x`,
                    `${getImageUrl(props.offerImage, { mode: 'crop', width: 1200, heightratio: 334 / 380 })} 2x`,
                ].join(',') }),
            props.tag && React.createElement(S.TagText, null, props.tag),
            props.brandLogo && (React.createElement(S.BrandLogo, { alt: props.brandLogoAltText ?? '', loading: "lazy", role: props.brandLogoAltText ? undefined : 'presentation', src: getImageUrl(props.brandLogo, { mode: 'pad', height: 38 }), srcSet: [
                    `${getImageUrl(props.brandLogo, { mode: 'pad', height: 38 })} 1x`,
                    `${getImageUrl(props.brandLogo, { mode: 'pad', height: 76 })} 2x`,
                ].join(',') }))),
        React.createElement(S.OfferTextContainer, null,
            React.createElement(S.Price, { goldBackground: props.goldBackground }, props.offerTitle)),
        React.createElement(S.ContentContainer, null,
            React.createElement(S.Title, null, props.offerCarTitle),
            props.offerDetailText && (React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: props.offerDetailText } })),
            React.createElement(LinkButton, { branding: "primary", title: props.buttonText, href: props.buttonLink }))));
};
export default OfferDetailCard;
